/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var OnboardingStatus;

(function (OnboardingStatus) {
  OnboardingStatus["TOBA_NOT_SIGNED"] = "toba_not_signed";
  OnboardingStatus["TOBA_SIGNED"] = "toba_signed";
  OnboardingStatus["NOT_APPROVED"] = "not_approved";
  OnboardingStatus["APPROVED"] = "approved";
})(OnboardingStatus || (OnboardingStatus = {}));